import React from 'react';
import { useToast } from '@/hooks/shared/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  type ToastProps,
} from '@/components/ui/toast';
import { XCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

const variantIcons: Record<NonNullable<ToastProps['variant']>, React.ReactNode> = {
  default: <Info className="h-6 2-6 text-blue-500" />,
  destructive: <XCircle className="h-6 2-6 text-red-500" />,
  success: <CheckCircle className="h-6 2-6 text-green-500" />,
};
const viewPortClassName =
  'fixed bottom-0 left-1/2 z-[100] flex max-h-screen w-full -translate-x-[calc(50%-56px)] flex-col-reverse p-4 sm:w-auto min-w-fit md:max-w-[600px]';
export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant = 'default', ...props }) {
        const Icon = variantIcons[variant as 'default'];
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-center h-full gap-3">
              {Icon && <div className="">{Icon}</div>}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport className={viewPortClassName} />
    </ToastProvider>
  );
}
